import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';

import 'video.js/dist/video-js.css'

// 全局基础样式：统一 font-family / 字号 / Vant 组件样式（首页、彩票页、选妃页通用）
import './assets/css/base.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);
// 读取用户上次选择的语言，没有则默认中文（不再每次强制覆盖）
const savedLang = localStorage.getItem('lang') || 'zh_cn';
const i18n = new VueI18n({
  globalInjection: true,
  locale: savedLang,
  messages: {
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'en_us': require('./assets/languages/en_us.json'),
    // 其他语言暂时注释，调试好中文和英文后再启用
    // 'yn_yu': require('./assets/languages/yn_yu.json'),
    // 'es_spa': require('./assets/languages/es_spa.json'),
    // 'ms_my': require('./assets/languages/ms_my.json'),
    // 'idn_yu': require('./assets/languages/idn_yu.json'),
    // 'ko_hy': require('./assets/languages/ko_hy.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
